/**
 * @description 投保方式代碼 (enum)
 */
export enum InsureModeCodesEnum {
  /** 網路投保 */
  Propose = 'C',
  /** 網路要保 */
  Apply = 'B'
}
